export default __webpack_public_path__ + "static/visa-offers-b825b1a8c52939fa1e1327e09397b7ca.png";